var codeblock_default = {
  "blockStyleSpacing": "v5bWQ",
  "codeBlock": "c6-Uz v5bWQ",
  "renderedInTable": "-ortu"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
